export default __webpack_public_path__ + "static/media/velotax-light.9bb89f4f.svg";